type Props = {
  onClick: () => void;
  disabled?: boolean;
  label?: string;
  className?: string;
};

const OnboardingBackChevron = ({
  onClick,
  disabled = false,
  label = 'Go to previous step',
  className = '',
}: Props) => (
  <button
    type="button"
    className={[
      'min-h-10 min-w-10 cursor-pointer border-0 bg-transparent p-0 text-muted-foreground',
      'transition-colors hover:not-disabled:text-foreground active:not-disabled:scale-[0.96]',
      'disabled:cursor-not-allowed disabled:opacity-35',
      className,
    ]
      .filter(Boolean)
      .join(' ')}
    onClick={onClick}
    disabled={disabled}
    aria-label={label}
    title={label}
  >
    <svg
      className="block h-7 w-7 md:h-9 md:w-9"
      width="36"
      height="36"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
    >
      <path
        d="M19 12H5M5 12L12 19M5 12L12 5"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  </button>
);

export default OnboardingBackChevron;
